module.exports = __webpack_public_path__ + "static/media/pic2.eb8abb63.jpg";